var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.add_role"),
            "close-on-click-modal": false,
            visible: _vm.dialogUserVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _c("div", { staticClass: "add-role-dec" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("system.role_details")))]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("tips.manage_details_new_role"))),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "add-role-form" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "200px",
                      rules: _vm.rules,
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("system.role_name"),
                          prop: "role_name",
                          required: "",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "search-frame",
                          attrs: {
                            size: "small",
                            placeholder: "Enter Role Name",
                            autocomplete: "off",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.role_name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "role_name", $$v)
                            },
                            expression: "form.role_name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("system.remark"),
                          prop: "remark",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "search-frame",
                          attrs: {
                            size: "small",
                            placeholder: "Enter your message here",
                            autocomplete: "off",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remark", $$v)
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "add-role-dec" }, [
                      _c("p", [_vm._v(_vm._s(_vm.$t("system.permissions")))]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("tips.following_permission_granted_role")
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "role-item-line" }),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-top": "10px" },
                        attrs: { prop: "role_auths" },
                      },
                      [
                        _c("SystemMchMenu", {
                          attrs: {
                            "menu-list": _vm.menuList,
                            "auth-list": _vm.form.role_auths,
                            "modal-flag": 1,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogUserVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.listLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitAddRole("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }